import React, { useEffect, useRef, useState } from "react";
import { Button } from "../../../design/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogDescription,
  DialogTitle,
} from "../../../design/dialog";
import { useDiscoveryRequestTaskResponse } from "../../../contexts/DiscoveryRequestTaskResponseContext";
import { DiscoveryRequestTaskResponse } from "../../../models/DiscoveryRequestTaskResponse";
import { EditableFile } from "../../../models/EditableFile";

interface Props {
  discoveryRequestTaskResponse?: DiscoveryRequestTaskResponse;
  onCreate?: (newDiscoveryRequestTaskResponseId: string) => Promise<void>;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const DiscoveryRequestTaskResponseDialog: React.FC<Props> = ({
  discoveryRequestTaskResponse,
  onCreate,
  isOpen,
  setIsOpen,
}) => {
  const {
    createDiscoveryRequestTaskResponse,
    updateDiscoveryRequestTaskResponse,
  } = useDiscoveryRequestTaskResponse();
  const [isSaving, setIsSaving] = useState(false);
  const [file, setFile] = useState<EditableFile | null>(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = async () => {};

  const clearForm = () => {
    setTitle("");
    setDescription("");
    setFile(null);
    setIsSaving(false);
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onClose={setIsOpen}>
      <DialogTitle>
        {discoveryRequestTaskResponse
          ? "Edit DiscoveryRequestTaskResponse"
          : "Create DiscoveryRequestTaskResponse"}
      </DialogTitle>
      <DialogBody></DialogBody>
      <DialogActions>
        <Button plain onClick={clearForm}>
          Cancel
        </Button>
        <Button disabled={isSaving} onClick={handleSubmit}>
          {isSaving ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DiscoveryRequestTaskResponseDialog;
